import React, { useContext, useState } from 'react'
import GloblePopup from '../common/GloblePopup'
import { GlobalContext } from '../global/GlobalProvider';
import config from '../config';
import { useNavigate } from 'react-router';
import OTPVerifyPopup from './OTPVerifyPopup';
import { useTranslation } from 'react-i18next';

export default function LoginPopup() {
    const { t, i18n } = useTranslation();
    const { isLoggedIn, isLoggedOut, setAlertMsg, openSuccessPopup, openErrorPopup,isBannerOpend,setIsBannerOpen } = useContext(GlobalContext);
    const {setLoginPop, loginPopupOpen, setTelegramPop } = useContext(GlobalContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loding, setLoading] = useState(false);
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(true);
    const [loginData, setLoginData] = useState();


    const handleLogin = () => {
        let isValid = true;

        // Validate Username
        if (!username.trim()) {
          openErrorPopup();
          setAlertMsg("Username cannot be empty!");
          isValid = false;
          return;
        } else {
          setAlertMsg(""); // Clear error if valid
        }

        // Validate Password
        if (!password.trim()) {
          openErrorPopup();
          setAlertMsg("Password cannot be empty!");
          isValid = false;
          return;
        } else {
          setAlertMsg(""); // Clear error if valid
        }

        if (isValid) {
          setLoading(true);
          const loginData = {
            userName: username,
            password: password,
            whiteLabelName: config.WhiteLable
          };

          fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/userLoginworld`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(loginData),
          }).then((response) => response.json())
          .then((data) => {
            setLoading(false);
            
            localStorage.setItem('bannerOpen',false)
            config.bannerOpen = false;
            console.log("Login success:", data);
            setLoginData(data);
            if (data.token && data.user && data.sessionId) {
              if (data.user.issecureauthenable) {
                config.userData = data;
                setLoginPop(false);
                setTelegramPop(true);
                // <OTPVerifyPopup data={data} />
              } else {
                setLoginPop(false);
                sessionStorage.setItem("token", data.token);
                sessionStorage.setItem("sessionId", data.sessionId);
                sessionStorage.setItem("userinfo", JSON.stringify(data.user));
                sessionStorage.setItem("issecureauthenable", data.user?.issecureauthenable ? data.user?.issecureauthenable : false);
                sessionStorage.setItem("userId",data.user._id)
                sessionStorage.setItem("loggedIn", "true");
                sessionStorage.setItem('isOneClicked',data?.user?.oneclickstatus)
                sessionStorage.setItem('oneClickAmount',data?.user?.oneclickstack)
                sessionStorage.setItem('passwordchanged',data?.user?.passwordchanged)
                isLoggedIn();
                openSuccessPopup();
                setAlertMsg("Login Successful!");
                setUsername("");
                setPassword("");
                isLoggedIn();

                window.location.replace("/sport");
              }
            } else {
              setAlertMsg(data.message)
              openErrorPopup();
            }
          })
          .catch((error) => {
            setLoading(true);
            setLoginPop(false);
            console.error("Error:", error);
          });
        }
      };

      const demoHandleClick = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/userLoginworld`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: "Demo" }),
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            setLoginPop(false);
            // console.log('Login success:', data);
            if (data.token && data.user && data.sessionId) {
              localStorage.setItem('bannerOpen',false)
              config.bannerOpen = false;
              sessionStorage.setItem("token", data.token);
              sessionStorage.setItem("sessionId", data.sessionId);
              sessionStorage.setItem("userinfo", JSON.stringify(data.user));
              sessionStorage.setItem("issecureauthenable", data.user?.issecureauthenable ? data.user?.issecureauthenable : false);
              sessionStorage.setItem("userId", data.user._id)
              sessionStorage.setItem("loggedIn", "true");
              isLoggedIn();
              window.location.replace("/sport");
              openSuccessPopup();
              setAlertMsg("Login Successful!");
              isLoggedIn();
              // setIsBannerOpen(true);
            } else {
              setAlertMsg(data.message)
              openErrorPopup();
              setLoginPop(false);
            }
          })
          .catch((error) => {
            setLoading(false);
            setLoginPop(false);
            console.error("Error:", error);
          });
      };

  return (
    <GloblePopup
                isOpen={loginPopupOpen}
                onClose={() => setLoginPop(false)}
                title={t("login")}
                cancelText="Close"
                className="login-modal"
            >
            <>
                <form>
                    <div className="form-group">
                        <label className="user-email-text">{t('usernameLogin')}</label>
                        <input type="text" placeholder={t("Enter Username")} autocomplete="new-username" name="username" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)}/>
                    </div>
                    <div className="form-group">
                        <label className="user-email-text">{t('passwordLogin')}</label>
                        <div className="input-group"><input placeholder={t("Enter Password")} name="password" autocomplete="new-password" type={showPassword ? "text" : "password"} className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                            <div className="input-group-append">
                                <button type="button" className="btn btn-secondary password-visible" onClick={() => setShowPassword((prev) => !prev)}><i aria-hidden="true" className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="checkbox">
                        <input type="checkbox" id="customCheck" className="custom-control-input" checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />
                            <label htmlFor="customCheck" className="custom-control-label">I am at least <a href="#" className="red-txt" role="button">18 years</a> of age and I have read, accept and agree to the <a href="/terms-and-conditions" className='login-link-txt' target="_blank">{t('Terms and Conditions')} </a>, <a href="/responsible-gaming" className='login-link-txt' target="_blank">{('Responsible Gaming')} </a>, <a href="https://www.gamcare.org.uk/" target="_blank">{t('GameCare')}</a>, <a href="https://www.gamblingtherapy.org/en" className='login-link-txt' target="_blank">{t('Gambling Therapy')}</a>
                            </label>
                        </div>
                    </div>
                    <div className="form-group submit-btn-sec">
                        <button type="button" className="btn btn-primary submit-btn" disabled={!isChecked} onClick={handleLogin}> {t('login')} </button>
                        <div class="login-btn-devider"> <span>or</span> </div>
                        <button type="button" className="btn btn-primary submit-btn" onClick={() => demoHandleClick()}> {t('Request a Demo')} </button>
                    </div>
                    <small className="recaptchaTerms">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" className='login-link-txt'>Privacy Policy</a> and <a href="https://policies.google.com/terms" className='login-link-txt'>Terms of Service</a> apply. </small>
                </form>

                <div className={`inner-loader ${loding ? 'show' :''}`}></div>
                </>
            </GloblePopup>
  )
}
